<div class="dialog-header">
  <h3 *ngIf="getInputData().view == 'CHANGE_CAR_WORKSHOP_MODAL'">
    {{ "service-request.change-car-workshop-modal.title" | translate }}
  </h3>
  <h3 *ngIf="getInputData().view == 'RESCHEDULE_DATE_MODAL'">
    {{
      "service-request.reschedule-modal.reschedule-same-carworkshop" | translate
    }}
  </h3>
  <button
    class="close-button"
    mat-icon-button
    tabindex="-1"
    cdkFocusInitial
    (click)="closeDialog()"
    id="stepBack-form-button-close"
  >
    <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
  </button>
</div>

<mat-dialog-content>
  <ng-container *ngIf="getInputData().view == 'CHANGE_CAR_WORKSHOP_MODAL'">
    <mat-vertical-stepper
      linear
      #stepper
      (selectionChange)="onStepChange($event)"
    >
      <mat-step
        [stepControl]="formCarworkshopSpecialty"
        *ngIf="getInputData().serviceType === 'CORRECTIVE'"
      >
        <ng-template matStepLabel>{{
          "carworkshop-specialty" | translate
        }}</ng-template>
        <form [formGroup]="formCarworkshopSpecialty">
          <div class="row-fx-legacy" *ngIf="isLightVehicle">
            <mat-form-field>
              <mat-label>{{ "carworkshop-specialty" | translate }}</mat-label
              ><mat-select
                formControlName="serviceCategories"
                required
                (selectionChange)="canSearchCarworkshop = false"
              >
                <mat-option
                  *ngFor="let service of servicesCategories"
                  [value]="service.code"
                >
                  {{ "car-workshop-category." + service.code | translate }}
                </mat-option>
              </mat-select>

              <mat-error
                *ngIf="
                  formCarworkshopSpecialty
                    .get('serviceCategories')
                    .hasError('required')
                "
                >{{ "required-carworkshop-specialty" | translate }}</mat-error
              >
            </mat-form-field>
          </div>

          <div class="row-fx-legacy" *ngIf="!isLightVehicle">
            <mat-form-field>
              <mat-label translate>carworkshop-specialty</mat-label>
              <mat-select
                formControlName="servicesProvided"
                multiple
                required
                (selectionChange)="canSearchCarworkshop = false"
              >
                <mat-option
                  *ngFor="let service of heavyServicesProvided"
                  [value]="service.code"
                >
                  {{
                    "car-workshop-services-provided." + service.code | translate
                  }}
                </mat-option>
              </mat-select>

              <mat-error
                *ngIf="
                  formCarworkshopSpecialty
                    .get('servicesProvided')
                    .hasError('required')
                "
                >{{ "required-carworkshop-specialty" | translate }}</mat-error
              >
            </mat-form-field>
          </div>
        </form>

        <div class="buttons">
          <button mat-button matStepperNext>
            {{ "button-next" | translate }}
          </button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>{{
          "input-carworkshop-selection" | translate
        }}</ng-template>
        <app-smartfleet-find-carworkshop-maps
          *ngIf="canSearchCarworkshop"
          (onChange)="handleCarWorkshopChange($event)"
          [clientId]="getInputData().clientId"
          [vehicleId]="getInputData().vehicleId"
          [serviceType]="getInputData().serviceType"
          [serviceCategories]="
            getInputData().serviceType == 'TIRES'
              ? 'TIRES'
              : formCarworkshopSpecialty.get('serviceCategories').value
          "
          [servicesProvided]="
            formCarworkshopSpecialty.get('servicesProvided').value
          "
        ></app-smartfleet-find-carworkshop-maps>

        <div class="buttons">
          <button mat-button matStepperNext>
            {{ "button-next" | translate }}
          </button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>{{
          "input-scheduling-date" | translate
        }}</ng-template>
        <app-driveb-select-date-period-available-carworkshop
          [setUnavailableDatesPeriods]="unavailableDatesPeriods"
          [periods]="periods"
          [isBackofficeUserLogged]="getInputData().isBackofficeUserLogged"
          (onChange)="setNewDatePeriod($event)"
          [daysAdvanceForAppointments]="
            getInputData().daysAdvanceForAppointments
          "
        >
        </app-driveb-select-date-period-available-carworkshop>

        <div class="buttons">
          <button mat-button matStepperPrevious>
            {{ "button-back" | translate }}
          </button>
          <button mat-button (click)="submit()" [disabled]="form.invalid">
            {{ "input-save" | translate }}
          </button>
        </div>
      </mat-step>
    </mat-vertical-stepper>
  </ng-container>

  <ng-container *ngIf="getInputData().view == 'RESCHEDULE_DATE_MODAL'">
    <div style="margin: 32px 0">
      <app-driveb-select-date-period-available-carworkshop
        [setUnavailableDatesPeriods]="unavailableDatesPeriods"
        [periods]="periods"
        [isBackofficeUserLogged]="getInputData().isBackofficeUserLogged"
        (onChange)="setNewDatePeriod($event)"
        [daysAdvanceForAppointments]="getInputData().daysAdvanceForAppointments"
      >
      </app-driveb-select-date-period-available-carworkshop>
    </div>

    <div class="buttons">
      <button mat-button (click)="submit()" [disabled]="form.invalid">
        {{ "input-save" | translate }}
      </button>
    </div>
  </ng-container>
</mat-dialog-content>
